import axiosClient from '@api/axios-client'
import { useAxiosQuery } from './useAxiosQuery'
import { QueryClient } from '@tanstack/react-query'

type CaarlConnectionLink = {
  connectionLink: string
}

const getCaarlConnectionLink = () => {
  return axiosClient.get('/api/caarl/connection-link').then(response => response.data)
}

const queryOptions = (userId: number, options?: any) => ({
  queryKey: ['caarl-connection-link', userId],
  queryFn: getCaarlConnectionLink,
  staleTime: 1000 * 60 * 9, // 9 minutes (actual links validity is 10 minutes)
  ...options,
})

export const useCaarlConnectionLink = (userId: number, options?: any) =>
  useAxiosQuery<CaarlConnectionLink>(queryOptions(userId, options))

export const getOrRefetchCaarlConnectionLink = async (queryClient: QueryClient, userId: number) => {
  return queryClient.fetchQuery(queryOptions(userId))
}